export function useAddBlankRows() {
    const addBlankRows = (rows, request) => {
        if (rows) {
            const requestedSymbols = request.symbols.split(',');
            const uniqSymbols = requestedSymbols.filter((value, item, array) => value === '~' || array.indexOf(value) === item);

            uniqSymbols.map((symbol, index) => {
                if (symbol === '~') {
                    rows.splice(index, 0, { blankRow: true });
                }
            });
        }

        return rows;
    };

    return {
        addBlankRows,
    };
}
